'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _src = require('./src');

var _src2 = _interopRequireDefault(_src);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _src2['default']; // rc-upload 2.9.4